// Helpers for producing the final banner image from the interactive cropper.
// The output is rendered onto a canvas at the exact mobile-banner aspect ratio
// so whatever the admin frames is pixel-for-pixel what the mobile app shows.

const loadImage = src =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    // Local object URLs are same-origin, but set this defensively so the
    // canvas never becomes tainted (which would block toBlob()).
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = src;
  });

/**
 * Crop `imageSrc` to `pixelCrop` (the {x, y, width, height} region returned by
 * react-easy-crop) and scale it into a canvas of `outputWidth` x `outputHeight`.
 * Returns a JPEG Blob ready to upload.
 */
export const getCroppedBlob = async (imageSrc, pixelCrop, outputWidth, outputHeight) => {
  const image = await loadImage(imageSrc);

  const canvas = document.createElement('canvas');
  canvas.width = outputWidth;
  canvas.height = outputHeight;

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Could not get canvas context');
  }

  // White backdrop so any transparency in the source becomes white instead of
  // black when exported as JPEG.
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, outputWidth, outputHeight);

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputWidth,
    outputHeight
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (!blob) {
          reject(new Error('Failed to export cropped image'));
          return;
        }
        resolve(blob);
      },
      'image/jpeg',
      0.92
    );
  });
};
